export default "__VITE_ASSET__BDaXG3Qu__"